import { fabric } from 'fabric';
import { addArrow, getTheNearestPort, distance, getPortFromDiagramObj, getPathFromTwoPoints } from './fabric_flowchart';
import { updateLabel } from './label';
import { updatePoints } from './utils';
import { getIndex } from './container';
import { FABRIC_CUSTOM_OBJECT } from '../utils';

const initialControl = {
  fill: '#529ff8',
  originX: 'center',
  originY: 'center',
  isNotObj: true,
  isControlPoint: true,
  hasControls: false,
  hasBorders: false,
  hoverCursor: 'all-scroll',
};
const control1 = new fabric.Circle({ ...initialControl });
const control2 = new fabric.Circle({ ...initialControl });
let line;
let showAllPort = false;
let eventOn = false;
let onMouseDown;
let listCircle = [];
export function addArrowLine(points, destination, arrowStyle) {
  const start = { ...points[0] };

  if (arrowStyle === 1) {
    const r = {
      x1: points[0].x,
      y1: points[0].y,
      x2: destination.x,
      y2: destination.y,
    };
    const headlen = 8; // length of head in pixels
    const tmp = headlen * Math.cos(Math.PI / 6);

    const angle = Math.atan2(r.y2 - r.y1, r.x2 - r.x1);
    const A = {
      x: r.x2 - tmp * Math.cos(angle),
      y: r.y2 - tmp * Math.sin(angle),
    };
    const A1 = {
      x: r.x2 - headlen * Math.cos(angle - Math.PI / 6),
      y: r.y2 - headlen * Math.sin(angle - Math.PI / 6),
    };
    const A2 = {
      x: r.x2 - headlen * Math.cos(angle + Math.PI / 6),
      y: r.y2 - headlen * Math.sin(angle + Math.PI / 6),
    };
    while (points.length > 0) points.pop();
    points.push(start, A, A1, destination, A2, A, start);
  }
}
function drawPath() {
  const { canvas } = window;
  let newpoints;
  if (line.name && (line.name.search('Line') !== -1 || line.name.search('line') !== -1)) {
    newpoints = [
      { x: control1.left, y: control1.top },
      { x: control2.left, y: control2.top },
    ];
    if (line.name.search('Arrow') !== -1) {
      addArrowLine(newpoints, { ...newpoints[1] }, 1);
    }
  } else {
    newpoints = getPathFromTwoPoints(
      { x: control1.left, y: control1.top },
      { x: control2.left, y: control2.top },
      line.fromPort,
      line.toPort,
    );
    addArrow(newpoints, line.strokeWidth);
  }
  const index = getIndex(line);
  canvas.remove(line);

  const newline = new fabric.Polyline(newpoints, {
    padding: 20,
    name: line.name,
    fill: line.fill,
    stroke: line.stroke,
    strokeWidth: line.strokeWidth,
    strokeDashArray: line.strokeDashArray,
    strokeLineCap: line.strokeLineCap,
    toPort: line.toPort,
    fromPort: line.fromPort,
    toNode: line.toNode,
    fromNode: line.fromNode,
    toId: line.toId,
    fromId: line.fromId,
    hasControls: line.hasControls,
    hasBorders: line.hasBorders,
    lockMovementX: line.lockMovementX,
    lockMovementY: line.lockMovementY,
    perPixelTargetFind: line.perPixelTargetFind,
    destination: { x: control2.left, y: control2.top },
    isNotObj: line.isNotObj,
    angle: line.angle,
    id: line.id,
    objectCaching: false,
  });
  canvas.insertAt(newline, index);
  updateLabel(newline);
  line = newline;
}
function autoFixLine() {
  if (line.name === FABRIC_CUSTOM_OBJECT.verticalLine || line.name === FABRIC_CUSTOM_OBJECT.horizontalLine) return;
  let tmpStart;
  let tmpEnd;
  const eps = 200;
  const { canvas } = window;
  const point1 = { x: control1.left, y: control1.top };
  const point2 = { x: control2.left, y: control2.top };
  let fromPort1 = { x: 10000, y: 10000 };
  let fromPort2 = { x: 10000, y: 10000 };
  canvas.getObjects().forEach((obj) => {
    if (obj.isDiagram) {
      tmpStart = getTheNearestPort(point1, obj);
      tmpEnd = getTheNearestPort(point2, obj);
      if (distance(tmpStart, point1) < distance(fromPort1, point1)) fromPort1 = { ...tmpStart };
      if (distance(tmpEnd, point2) < distance(fromPort2, point2)) fromPort2 = { ...tmpEnd };
    }
    return obj;
  });
  if (distance(point1, fromPort1) < eps) {
    control1.set({ left: fromPort1.x, top: fromPort1.y });
    control1.setCoords();
    line.set({
      fromPort: fromPort1.fromPort,
      fromNode: fromPort1.fromNode,
      fromId: fromPort1.id,
    });
  } else line.set({ fromNode: null, fromId: null });
  if (distance(point2, fromPort2) < eps) {
    control2.set({ left: fromPort2.x, top: fromPort2.y });
    control2.setCoords();
    line.set({
      toPort: fromPort2.fromPort,
      toNode: fromPort2.fromNode,
      toId: fromPort2.fromNode.id,
    });
  } else line.set({ toNode: null, toId: null });
}
function onEditLine() {
  control1.setCoords();
  control2.setCoords();
  drawPath();
}
function onObjMoving(event) {
  if (line.name === FABRIC_CUSTOM_OBJECT.verticalLine || line.name === FABRIC_CUSTOM_OBJECT.horizontalLine) {
    onEditLine(event);
    return;
  }
  const { canvas } = window;
  if (!showAllPort) {
    const listPort = getPortFromDiagramObj(null);
    listPort.map((e) =>
      listCircle.push(
        new fabric.Circle({
          left: e.x - 3,
          top: e.y - 3,
          strokeWidth: 1,
          opacity: 0.5,
          radius: 3,
          isNotObj: true,
          fill: 'blue',
          stroke: 'blue',
        }),
      ),
    );
    listCircle.map((e) => {
      canvas.add(e);
      return e;
    });
    showAllPort = true;
  }
  autoFixLine();
  control1.setCoords();
  control2.setCoords();
  drawPath();
}
function onMouseUp(event) {
  const { canvas } = window;
  if (showAllPort) {
    canvas.remove(...listCircle);
    showAllPort = false;
    listCircle = [];
  }
  autoFixLine();
  drawPath();
  if (eventOn) {
    if (event.target && (event.target === control1 || event.target === control2)) return;
    canvas.remove(control1, control2);
    canvas.off('object:moving', onObjMoving);
    canvas.off('mouse:up', onMouseUp);
    canvas.off('mouse:down', onMouseDown);
    eventOn = false;
  }
}
export function deleteControl() {
  const { canvas } = window;
  canvas.remove(control1, control2);
  if (eventOn) {
    canvas.off('object:moving', onObjMoving);
    canvas.off('mouse:up', onMouseUp);
    canvas.off('mouse:down', onMouseDown);
    eventOn = false;
  }
}
function addControl() {
  const { canvas } = window;
  canvas.add(control1, control2);
  if (!eventOn) {
    canvas.on('object:moving', onObjMoving);
    canvas.on('mouse:up', onMouseUp);
    canvas.on('mouse:down', onMouseDown);
    eventOn = true;
  }
}
onMouseDown = function(event) {
  if (!event.target || (event.target !== control1 && event.target !== control2)) deleteControl();
};

export function addingControlPoints(polyline) {
  line = null;
  window.canvas.getObjects().map((e) => {
    if ((e.id === polyline.id || e.id === polyline.copyId) && e.name !== 'highlightLabel' && !e.isNotObj) line = e;
    return e;
  });
  if (line.type === FABRIC_CUSTOM_OBJECT.polyline) line = updatePoints(line);
  const p1 = line.points[0];
  const p2 = line.destination;
  if (!p2) return;
  const radius = Math.max(line.strokeWidth + 2, 5);
  control1.set({
    radius,
    top: p1.y,
    left: p1.x,
    line,
  });
  control2.set({
    radius,
    top: p2.y,
    left: p2.x,
    line,
  });
  control1.setCoords();
  control2.setCoords();
  control1.set({
    lockMovementX: false,
    lockMovementY: false,
  });
  control2.set({
    lockMovementX: false,
    lockMovementY: false,
  });

  if (line.name && line.name === FABRIC_CUSTOM_OBJECT.verticalLine) {
    control1.set({ lockMovementX: true });
    control2.set({ lockMovementX: true });
  }
  if (line.name && line.name === FABRIC_CUSTOM_OBJECT.horizontalLine) {
    control1.set({ lockMovementY: true });
    control2.set({ lockMovementY: true });
  }
  const oldState = {
    angle: line.angle,
    fromPort: line.fromPort,
    fromNode: line.fromNode,
    toPort: line.toPort,
    toNode: line.toNode,
  };
  autoFixLine();
  const eps = 3;
  const isChanged =
    oldState.angle !== line.angle ||
    oldState.toNode !== line.toNode ||
    oldState.fromNode !== line.fromNode ||
    oldState.toPort !== line.toPort ||
    oldState.fromPort !== line.fromPort ||
    Math.abs(line.destination.x - control2.left) > eps ||
    Math.abs(line.destination.y - control2.top) > eps ||
    Math.abs(line.points[0].x - control1.left) > eps ||
    Math.abs(line.points[0].y - control1.top) > eps;
  if (isChanged) drawPath();
  updateLabel(line);
  addControl();
}

export function deleteLabel(polylineId) {
  const { canvas } = window;
  const listLabel = canvas.getObjects();
  listLabel.forEach((e) => {
    if (e.polylineId === polylineId) canvas.remove(e);
  });
  canvas.requestRenderAll();
}
